// Duração da sessão de treino. Step NOVO (pergunta "tempo" do
// Objetivo.dc.html).
//
// Os `value` são os MESMOS quatro baldes que o gerador de plano grava em
// `tempoSessao` ("rapido - Até 20 minutos", …). Um vocabulário só: o que o
// onboarding responde entra direto no payload da geração, sem tradução.

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "rapido - Até 20 minutos", label: "Rápido", sub: "até 20 min" },
  { value: "curto - De 20 a 40 minutos", label: "Curto", sub: "20–40 min" },
  { value: "normal - De 40 a 60 minutos", label: "Normal", sub: "40–60 min" },
  { value: "longo - 60 minutos ou mais", label: "Longo", sub: "mais de 1 h" },
];

const StepTempoTreino = ({ setCanProceed, setStepData }) => {
  const [tempo, setTempo] = useState("");

  useEffect(() => {
    const valido = Boolean(tempo);
    setCanProceed(valido);
    setStepData(valido ? { SESSION_TIME: tempo } : null);
  }, [tempo, setCanProceed, setStepData]);

  return <Opcoes opcoes={OPCOES} valor={tempo} onSelecionar={setTempo} nome="Tempo por treino" />;
};

export default StepTempoTreino;
